import ErrorLog from './routes/error_log/ErrorLog.vue';
import GuideBook from './routes/guide_book/GuideBook.vue';
import createGuideBook from './routes/guide_book/component/createGuideBook.vue';
import editGuideBook from './routes/guide_book/component/editGuideBook.vue';

const DeveloperRoutes = [
  {
    path: '/error-log',
    name: 'ErrorLog',
    component: ErrorLog,
  },
  {
    path: '/guide-book',
    name: 'GuideBook',
    component: GuideBook,
  },
  {
    path: '/create-guide-book',
    name: 'createGuideBook',
    component: createGuideBook,
  },
  {
    path: '/edit-guide-book/:id',
    name: 'editGuideBook',
    component: editGuideBook,
  },
];

export default DeveloperRoutes;
